import Games from './components/Games.vue';
import Developers from './components/Developers.vue';
import Platforms from './components/Platforms.vue';
import Regions from './components/Regions.vue';
import Profile from './components/Profile.vue';
import Login from './components/Login.vue';
import Logout from './components/Logout.vue';
import { authGuard } from "./auth/authGuard";

const routes = [
    { path: "/", redirect: '/games', beforeEnter: authGuard },
    { path: "/games", component: Games, name: 'games', beforeEnter: authGuard },
    { path: "/developers", component: Developers, name: 'developers', beforeEnter: authGuard },
    { path: "/platforms", component: Platforms, name: 'platforms', beforeEnter: authGuard },
    { path: "/regions", component: Regions, name: 'regions', beforeEnter: authGuard },
    { path: "/profile", component: Profile, name: 'profile', beforeEnter: authGuard },
    { path: "/login", component: Login, name: 'login' },
    { path: "/logout", component: Logout, name: 'logout' }
]

export default routes;
